import React, { useState, useEffect } from "react";
import {
  Mail,
  Phone,
  Lock,
  Eye,
  EyeOff,
  User,
  ChevronDown,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../image/Larana.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingIndicator from "../../pages/LoadingIndicator";
import Alert from "../../pages/Alert";
import axios from "axios";
const BackendUrl = process.env.REACT_APP_Backend_Url;

// Liste des indicatifs téléphoniques populaires
const countryCodes = [
  { code: "+93", country: "Afghanistan", flag: "🇦🇫" },
  { code: "+355", country: "Albanie", flag: "🇦🇱" },
  { code: "+213", country: "Algérie", flag: "🇩🇿" },
  { code: "+376", country: "Andorre", flag: "🇦🇩" },
  { code: "+244", country: "Angola", flag: "🇦🇴" },
  { code: "+54", country: "Argentine", flag: "🇦🇷" },
  { code: "+374", country: "Arménie", flag: "🇦🇲" },
  { code: "+61", country: "Australie", flag: "🇦🇺" },
  { code: "+43", country: "Autriche", flag: "🇦🇹" },
  { code: "+994", country: "Azerbaïdjan", flag: "🇦🇿" },
  { code: "+1242", country: "Bahamas", flag: "🇧🇸" },
  { code: "+973", country: "Bahreïn", flag: "🇧🇭" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩" },
  { code: "+32", country: "Belgique", flag: "🇧🇪" },
  { code: "+229", country: "Bénin", flag: "🇧🇯" },
  { code: "+975", country: "Bhoutan", flag: "🇧🇹" },
  { code: "+591", country: "Bolivie", flag: "🇧🇴" },
  { code: "+387", country: "Bosnie-Herzégovine", flag: "🇧🇦" },
  { code: "+267", country: "Botswana", flag: "🇧🇼" },
  { code: "+55", country: "Brésil", flag: "🇧🇷" },
  { code: "+673", country: "Brunei", flag: "🇧🇳" },
  { code: "+359", country: "Bulgarie", flag: "🇧🇬" },
  { code: "+226", country: "Burkina Faso", flag: "🇧🇫" },
  { code: "+257", country: "Burundi", flag: "🇧🇮" },
  { code: "+855", country: "Cambodge", flag: "🇰🇭" },
  { code: "+237", country: "Cameroun", flag: "🇨🇲" },
  { code: "+1", country: "Canada", flag: "🇨🇦" },
  { code: "+238", country: "Cap-Vert", flag: "🇨🇻" },
  { code: "+236", country: "République centrafricaine", flag: "🇨🇫" },
  { code: "+235", country: "Tchad", flag: "🇹🇩" },
  { code: "+56", country: "Chili", flag: "🇨🇱" },
  { code: "+86", country: "Chine", flag: "🇨🇳" },
  { code: "+57", country: "Colombie", flag: "🇨🇴" },
  { code: "+242", country: "Congo", flag: "🇨🇬" },
  { code: "+243", country: "RD Congo", flag: "🇨🇩" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "+225", country: "Côte d'Ivoire", flag: "🇨🇮" },
  { code: "+385", country: "Croatie", flag: "🇭🇷" },
  { code: "+53", country: "Cuba", flag: "🇨🇺" },
  { code: "+357", country: "Chypre", flag: "🇨🇾" },
  { code: "+420", country: "République tchèque", flag: "🇨🇿" },
  { code: "+45", country: "Danemark", flag: "🇩🇰" },
  { code: "+253", country: "Djibouti", flag: "🇩🇯" },
  { code: "+1809", country: "République dominicaine", flag: "🇩🇴" },
  { code: "+593", country: "Équateur", flag: "🇪🇨" },
  { code: "+20", country: "Égypte", flag: "🇪🇬" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻" },
  { code: "+240", country: "Guinée équatoriale", flag: "🇬🇶" },
  { code: "+291", country: "Érythrée", flag: "🇪🇷" },
  { code: "+372", country: "Estonie", flag: "🇪🇪" },
  { code: "+251", country: "Éthiopie", flag: "🇪🇹" },
  { code: "+679", country: "Fidji", flag: "🇫🇯" },
  { code: "+358", country: "Finlande", flag: "🇫🇮" },
  { code: "+33", country: "France", flag: "🇫🇷" },
  { code: "+241", country: "Gabon", flag: "🇬🇦" },
  { code: "+220", country: "Gambie", flag: "🇬🇲" },
  { code: "+995", country: "Géorgie", flag: "🇬🇪" },
  { code: "+49", country: "Allemagne", flag: "🇩🇪" },
  { code: "+233", country: "Ghana", flag: "🇬🇭" },
  { code: "+30", country: "Grèce", flag: "🇬🇷" },
  { code: "+299", country: "Groenland", flag: "🇬🇱" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹" },
  { code: "+224", country: "Guinée", flag: "🇬🇳" },
  { code: "+245", country: "Guinée-Bissau", flag: "🇬🇼" },
  { code: "+592", country: "Guyana", flag: "🇬🇾" },
  { code: "+509", country: "Haïti", flag: "🇭🇹" },
  { code: "+504", country: "Honduras", flag: "🇭🇳" },
  { code: "+852", country: "Hong Kong", flag: "🇭🇰" },
  { code: "+36", country: "Hongrie", flag: "🇭🇺" },
  { code: "+354", country: "Islande", flag: "🇮🇸" },
  { code: "+91", country: "Inde", flag: "🇮🇳" },
  { code: "+62", country: "Indonésie", flag: "🇮🇩" },
  { code: "+98", country: "Iran", flag: "🇮🇷" },
  { code: "+964", country: "Irak", flag: "🇮🇶" },
  { code: "+353", country: "Irlande", flag: "🇮🇪" },
  { code: "+972", country: "Israël", flag: "🇮🇱" },
  { code: "+39", country: "Italie", flag: "🇮🇹" },
  { code: "+1876", country: "Jamaïque", flag: "🇯🇲" },
  { code: "+81", country: "Japon", flag: "🇯🇵" },
  { code: "+962", country: "Jordanie", flag: "🇯🇴" },
  { code: "+7", country: "Kazakhstan", flag: "🇰🇿" },
  { code: "+254", country: "Kenya", flag: "🇰🇪" },
  { code: "+965", country: "Koweït", flag: "🇰🇼" },
  { code: "+996", country: "Kirghizistan", flag: "🇰🇬" },
  { code: "+856", country: "Laos", flag: "🇱🇦" },
  { code: "+371", country: "Lettonie", flag: "🇱🇻" },
  { code: "+961", country: "Liban", flag: "🇱🇧" },
  { code: "+266", country: "Lesotho", flag: "🇱🇸" },
  { code: "+231", country: "Libéria", flag: "🇱🇷" },
  { code: "+218", country: "Libye", flag: "🇱🇾" },
  { code: "+423", country: "Liechtenstein", flag: "🇱🇮" },
  { code: "+370", country: "Lituanie", flag: "🇱🇹" },
  { code: "+352", country: "Luxembourg", flag: "🇱🇺" },
  { code: "+853", country: "Macao", flag: "🇲🇴" },
  { code: "+389", country: "Macédoine du Nord", flag: "🇲🇰" },
  { code: "+261", country: "Madagascar", flag: "🇲🇬" },
  { code: "+265", country: "Malawi", flag: "🇲🇼" },
  { code: "+60", country: "Malaisie", flag: "🇲🇾" },
  { code: "+960", country: "Maldives", flag: "🇲🇻" },
  { code: "+223", country: "Mali", flag: "🇲🇱" },
  { code: "+356", country: "Malte", flag: "🇲🇹" },
  { code: "+222", country: "Mauritanie", flag: "🇲🇷" },
  { code: "+230", country: "Maurice", flag: "🇲🇺" },
  { code: "+52", country: "Mexique", flag: "🇲🇽" },
  { code: "+373", country: "Moldavie", flag: "🇲🇩" },
  { code: "+377", country: "Monaco", flag: "🇲🇨" },
  { code: "+976", country: "Mongolie", flag: "🇲🇳" },
  { code: "+382", country: "Monténégro", flag: "🇲🇪" },
  { code: "+212", country: "Maroc", flag: "🇲🇦" },
  { code: "+258", country: "Mozambique", flag: "🇲🇿" },
  { code: "+95", country: "Myanmar", flag: "🇲🇲" },
  { code: "+264", country: "Namibie", flag: "🇳🇦" },
  { code: "+977", country: "Népal", flag: "🇳🇵" },
  { code: "+31", country: "Pays-Bas", flag: "🇳🇱" },
  { code: "+64", country: "Nouvelle-Zélande", flag: "🇳🇿" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮" },
  { code: "+227", country: "Niger", flag: "🇳🇪" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { code: "+850", country: "Corée du Nord", flag: "🇰🇵" },
  { code: "+47", country: "Norvège", flag: "🇳🇴" },
  { code: "+968", country: "Oman", flag: "🇴🇲" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰" },
  { code: "+970", country: "Palestine", flag: "🇵🇸" },
  { code: "+507", country: "Panama", flag: "🇵🇦" },
  { code: "+675", country: "Papouasie-Nouvelle-Guinée", flag: "🇵🇬" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾" },
  { code: "+51", country: "Pérou", flag: "🇵🇪" },
  { code: "+63", country: "Philippines", flag: "🇵🇭" },
  { code: "+48", country: "Pologne", flag: "🇵🇱" },
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+974", country: "Qatar", flag: "🇶🇦" },
  { code: "+40", country: "Roumanie", flag: "🇷🇴" },
  { code: "+7", country: "Russie", flag: "🇷🇺" },
  { code: "+250", country: "Rwanda", flag: "🇷🇼" },
  { code: "+966", country: "Arabie saoudite", flag: "🇸🇦" },
  { code: "+221", country: "Sénégal", flag: "🇸🇳" },
  { code: "+381", country: "Serbie", flag: "🇷🇸" },
  { code: "+232", country: "Sierra Leone", flag: "🇸🇱" },
  { code: "+65", country: "Singapour", flag: "🇸🇬" },
  { code: "+421", country: "Slovaquie", flag: "🇸🇰" },
  { code: "+386", country: "Slovénie", flag: "🇸🇮" },
  { code: "+252", country: "Somalie", flag: "🇸🇴" },
  { code: "+27", country: "Afrique du Sud", flag: "🇿🇦" },
  { code: "+82", country: "Corée du Sud", flag: "🇰🇷" },
  { code: "+34", country: "Espagne", flag: "🇪🇸" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰" },
  { code: "+249", country: "Soudan", flag: "🇸🇩" },
  { code: "+211", country: "Soudan du Sud", flag: "🇸🇸" },
  { code: "+597", country: "Suriname", flag: "🇸🇷" },
  { code: "+268", country: "Eswatini", flag: "🇸🇿" },
  { code: "+46", country: "Suède", flag: "🇸🇪" },
  { code: "+41", country: "Suisse", flag: "🇨🇭" },
  { code: "+963", country: "Syrie", flag: "🇸🇾" },
  { code: "+886", country: "Taïwan", flag: "🇹🇼" },
  { code: "+992", country: "Tadjikistan", flag: "🇹🇯" },
  { code: "+255", country: "Tanzanie", flag: "🇹🇿" },
  { code: "+66", country: "Thaïlande", flag: "🇹🇭" },
  { code: "+228", country: "Togo", flag: "🇹🇬" },
  { code: "+216", country: "Tunisie", flag: "🇹🇳" },
  { code: "+90", country: "Turquie", flag: "🇹🇷" },
  { code: "+993", country: "Turkménistan", flag: "🇹🇲" },
  { code: "+256", country: "Ouganda", flag: "🇺🇬" },
  { code: "+380", country: "Ukraine", flag: "🇺🇦" },
  { code: "+971", country: "Émirats arabes unis", flag: "🇦🇪" },
  { code: "+44", country: "Royaume-Uni", flag: "🇬🇧" },
  { code: "+1", country: "États-Unis", flag: "🇺🇸" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾" },
  { code: "+998", country: "Ouzbékistan", flag: "🇺🇿" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳" },
  { code: "+967", country: "Yémen", flag: "🇾🇪" },
  { code: "+260", country: "Zambie", flag: "🇿🇲" },
  { code: "+263", country: "Zimbabwe", flag: "🇿🇼" },
];

function Inscription({ chg }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [alert, setAlert] = useState({
    visible: false,
    type: "",
    message: "",
  });
  const navigation = useNavigate();
  const navigue = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConf, setPasswordConf] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+227"); // Par défaut Niger
  const [whatsapp, setWhatsapp] = useState(true);
  const [formError, setFormError] = useState("");
  const [isEmailRequired, setIsEmailRequired] = useState(false);
  const [isPhoneRequired, setIsPhoneRequired] = useState(false);
  const regexPhone = /^[0-9]{8,}$/; // Regex pour valider le numéro sans l'indicatif
  const location = useLocation();

  // Fermer le dropdown si on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showCountryDropdown && !event.target.closest(".country-dropdown")) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCountryDropdown]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const showAlert = (type, message) => {
    setAlert({ visible: true, type, message });
    setTimeout(() => {
      setAlert({ visible: false, type: "", message: "" });
    }, 5000);
  };

  const handleAlert = (message) => {
    showAlert("success", message);
  };

  const handleAlertwar = (message) => {
    showAlert("warn", message);
  };

  const navigateBasedOnLocation = () => {
    const location = new URLSearchParams(window.location.search);
    const destinations = {
      fromCart: "/NotificationHeader",
      fromProfile: "/Profile",
      fromMore: "/More",
      fromMessages: "/Messages",
    };

    for (const [key, path] of Object.entries(destinations)) {
      if (location.get(key)) {
        navigation(`${path}?${key}=true`);
        return;
      }
    }
    navigation("/Home");
  };

  const validatePassword = (password) => {
    const minLength = 8;
    const regexUpperCase = /[A-Z]/;
    const regexLowerCase = /[a-z]/;
    const regexNumber = /[0-9]/;
    const regexSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

    if (!password || password.length < minLength) {
      handleAlertwar("Le mot de passe doit contenir au moins 8 caractères.");
      return false;
    }
    if (!regexUpperCase.test(password)) {
      handleAlertwar("Le mot de passe doit contenir au moins une lettre majuscule.");
      return false;
    }
    if (!regexLowerCase.test(password)) {
      handleAlertwar("Le mot de passe doit contenir au moins une lettre minuscule.");
      return false;
    }
    if (!regexNumber.test(password)) {
      handleAlertwar("Le mot de passe doit contenir au moins un chiffre.");
      return false;
    }
    // if (!regexSpecialChar.test(password)) {
    //   handleAlertwar("Le mot de passe doit contenir au moins un caractère spécial.");
    //   return false;
    // }

    return true;
  };


  const validateCredentials = (e) => {
    e.preventDefault();
    const nameV = name.trim();
    const emailV = email.trim();
    const passwordV = password.trim();
    const passwordCV = passwordConf.trim();
    const phoneNumberV = phoneNumber.trim();
    const formattedPhoneNumber = phoneNumberV
      ? `${countryCode}${phoneNumberV}`
      : "";

    setFormError("");

    // Validation du nom
    if (nameV === "" || name.length < 3) {
      handleAlertwar("Veuillez entrer un nom valide d'au moins 3 caractères.");
      return false;
    }

    // Validation du mot de passe
    if (!validatePassword(passwordV)) {
      return false;
    }


    // Validation de la confirmation du mot de passe
    if (passwordCV !== passwordV) {
      handleAlertwar("Les deux mots de passe ne correspondent pas.");
      return false;
    }

    // Validation de l'email si renseigné
    if (emailV !== "" && !validateEmail(emailV)) {
      handleAlertwar("Veuillez entrer une adresse e-mail valide.");
      return false;
    }

    // Validation du numéro de téléphone si renseigné
    if (phoneNumberV !== "" && !regexPhone.test(phoneNumberV)) {
      handleAlertwar(
        "Veuillez entrer un numéro de téléphone valide (minimum 8 chiffres)."
      );
      return false;
    }

    // Vérifier qu'au moins un des deux champs (email ou téléphone) est rempli
    if (emailV === "" && phoneNumberV === "") {
      handleAlertwar(
        "Veuillez fournir une adresse e-mail ou un numéro de téléphone."
      );
      return false;
    }





    // Envoi du formulaire
    setIsloading(true);
    axios
      .post(`${BackendUrl}/api/user/register`, {
        name: nameV,
        password: passwordV,
        email: emailV.length > 0 ? emailV : null,
        phoneNumber:
          formattedPhoneNumber.length > 0 ? formattedPhoneNumber : null,
        whatsapp,
      })
      .then((response) => {
        axios
          .post(
            `${BackendUrl}/api/user/login`,
            {
              email: emailV.length > 0 ? emailV : null,
              phoneNumber:
                formattedPhoneNumber.length > 0 ? formattedPhoneNumber : null,
              password: passwordV,
            },
            {
              withCredentials: true,
              credentials: "include",
            }
          )
          .then((user) => {
            const dateActuelle = new Date();
            const options = {
              year: "numeric",
              month: "long",
              day: "numeric",
            };
            const dateInscription = dateActuelle.toLocaleDateString(
              "fr-FR",
              options
            );

            const welcomeMessage = `
Bienvenue sur Kassarmoumarket !

Cher(e) ${nameV},

Félicitations et bienvenue dans la famille Kassarmoumarket ! 🎉

Nous sommes ravis de vous compter parmi nos nouveaux membres. Votre inscription a été confirmée avec succès le ${dateInscription}.

 Que pouvez-vous faire maintenant ?
• Parcourir notre large gamme de produits
• Profiter d'offres exclusives réservées aux membres
• Bénéficier de la livraison rapide
• Accéder à votre espace personnel pour suivre vos commandes

Vos informations de compte :
• Email : ${emailV || "À renseigner"}
• Téléphone : ${formattedPhoneNumber || "À renseigner"}

💡 Conseil : Complétez votre profil pour une expérience d'achat optimale et pour recevoir nos meilleures offres personnalisées.

Pour toute question ou assistance, notre équipe est disponible :
Email : support@kassarmoumarket.com
📞 Téléphone : +32 465 96 54 36

Nous vous souhaitons d'excellents achats sur Kassarmoumarket !

Cordialement,
L'équipe Kassarmou

---
Suivez-nous sur nos réseaux sociaux pour ne rien manquer de nos actualités et promotions !
`;


            if (user.status === 200) {
              const message = `<h1>Nouvel Utilisateur Inscrit sur Kassarmou</h1>
                  <p>Cher(e) Kassarmou,</p>
                  <p>Nous avons le plaisir de vous informer qu'un nouvel utilisateur s'est inscrit sur Kassarmoumarket. Voici les détails de l'utilisateur :</p>
                  <ul>
                      <li>Nom : ${nameV}</li>
                      <li>Adresse e-mail : ${emailV || "Non renseignée"}</li>
                      <li>Numéro de téléphone : ${formattedPhoneNumber || "Non renseigné"
                }</li>
                      <li>Date d'inscription : ${dateInscription}</li>
                  </ul>
                  <p>Vous pouvez vérifier ces informations dans notre base de données pour assurer le suivi approprié. N'hésitez pas à contacter l'utilisateur pour le saluer et l'orienter dans son expérience de magasinage en ligne.</p>
                  <p>Si vous avez des questions ou avez besoin d'informations supplémentaires, n'hésitez pas à me contacter à abdoulrazak9323@gmail.com ou par téléphone au [+227 87727501].</p>
                  <p>Nous sommes ravis d'accueillir de nouveaux utilisateurs sur Kassarmoumarket et espérons que cette nouvelle inscription contribuera à notre croissance continue.</p>
                  <p>Cordialement,</p>
                  <p>Abdoul Razak<br>L'équipe Kassarmou</p>`;

              handleAlert(user.data.message);
              setIsloading(false);
              chg("oui");
              navigateBasedOnLocation();
              localStorage.setItem(`userEcomme`, JSON.stringify(user.data));
            } else {
              handleAlertwar(user.data.message);
              setIsloading(false);
            }
          })
          .catch((error) => {
            setIsloading(false);
            if (error.response && error.response.status === 400) {
              handleAlertwar(error.response.data.message);
            } else {
              handleAlertwar(
                "Erreur lors de la connexion, veuillez réessayer."
              );
            }
          });
      })
      .catch((error) => {
        setIsloading(false);
        if (error.response) {
          if (error.response.status === 400 || error.response.status === 409) {
            handleAlertwar(error.response.data.message);
          } else {
            handleAlertwar("Une erreur est survenue, veuillez réessayer.");
          }
        } else {
          handleAlertwar(
            "Problème de connexion au serveur. Veuillez vérifier votre connexion internet."
          );
        }
      });
  };

  const handleToggleRequired = (field) => {
    if (field === "email") {
      setIsEmailRequired((prev) => !prev);
      if (!isEmailRequired && isPhoneRequired) {
        setIsPhoneRequired(false);
      }
    } else if (field === "phone") {
      setIsPhoneRequired((prev) => !prev);
      if (!isPhoneRequired && isEmailRequired) {
        setIsEmailRequired(false);
      }
    }
  };

  if (isloading) {
    return (
      <div
        style={{
          width: "100%",
          height: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1 style={{ textAlign: "center" }}>
          Connexion en cours, veuillez patienter...
          <LoadingIndicator loading={isloading} />
        </h1>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-xl shadow-lg">
        <div className="text-center">
          <img src={logo} alt="Logo" className="mx-auto w-25 h-25" />
          <h2
            className="mt-6 text-3xl font-bold text-[#E87E04]"
            style={{ textTransform: "uppercase" }}
          >
            Créer un compte
          </h2>
        </div>

        <form onSubmit={validateCredentials} className="space-y-6">
          {/* Nom complet */}
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            >
              Nom complet <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <User className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="name"
                name="name"
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#E87E04] focus:border-[#E87E04] sm:text-sm"
                placeholder="John Doe"
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <div className="flex justify-between items-center">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Adresse email{" "}
                {isEmailRequired && <span className="text-red-500">*</span>}
              </label>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="emailRequired"
                  checked={isEmailRequired}
                  onChange={() => handleToggleRequired("email")}
                  className="h-4 w-4 text-[#E87E04] focus:ring-[#E87E04] border-gray-300 rounded"
                />
                <label
                  htmlFor="emailRequired"
                  className="ml-2 text-xs text-gray-500"
                >
                  Obligatoire
                </label>
              </div>
            </div>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Mail className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="email"
                name="email"
                type="email"
                required={isEmailRequired}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#E87E04] focus:border-[#E87E04] sm:text-sm"
                placeholder="vous@exemple.com"
              />
            </div>
          </div>

          {/* Numéro de téléphone avec indicatif */}
          <div>
            <div className="flex justify-between items-center">
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700"
              >
                Numéro de téléphone{" "}
                {isPhoneRequired && <span className="text-red-500">*</span>}
              </label>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="phoneRequired"
                  checked={isPhoneRequired}
                  onChange={() => handleToggleRequired("phone")}
                  className="h-4 w-4 text-[#E87E04] focus:ring-[#E87E04] border-gray-300 rounded"
                />
                <label
                  htmlFor="phoneRequired"
                  className="ml-2 text-xs text-gray-500"
                >
                  Obligatoire
                </label>
              </div>
            </div>
            <div className="mt-1 flex rounded-md shadow-sm">
              {/* Indicatif pays */}
              <div className="relative country-dropdown">
                <button
                  type="button"
                  className="relative inline-flex items-center px-3 py-2 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#E87E04] focus:border-[#E87E04]"
                  onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                >
                  <span>
                    {countryCodes.find((c) => c.code === countryCode)?.flag}{" "}
                    {countryCode}
                  </span>
                  <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                {showCountryDropdown && (
                  <div className="absolute z-10 mt-1 w-56 bg-white shadow-lg max-h-60 rounded-md py-1 ring-1 ring-black ring-opacity-5 overflow-auto">
                    {countryCodes.map((country) => (
                      <div
                        key={country.code}
                        className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          setCountryCode(country.code);
                          setShowCountryDropdown(false);
                        }}
                      >
                        <span className="mr-2">{country.flag}</span>
                        <span>{country.country}</span>
                        <span className="ml-auto">{country.code}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Champ numéro */}
              <div className="relative flex-1">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Phone className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  required={isPhoneRequired}
                  value={phoneNumber}
                  onChange={(e) => {
                    // Ne permet que les chiffres
                    const value = e.target.value.replace(/\D/g, "");
                    setPhoneNumber(value);
                  }}
                  className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-r-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#E87E04] focus:border-[#E87E04] sm:text-sm"
                  placeholder="Numéro sans indicatif"
                />
              </div>
            </div>
            <div className="mt-1 flex items-center">
              <input
                id="whatsapp"
                name="whatsapp"
                type="checkbox"
                checked={whatsapp}
                onChange={(e) => setWhatsapp(e.target.checked)}
                className="h-4 w-4 text-[#E87E04] focus:ring-[#E87E04] border-gray-300 rounded"
              />
              <label htmlFor="whatsapp" className="ml-2 text-xs text-gray-500">
                Ce numéro est également mon WhatsApp
              </label>
            </div>
          </div>

          {/* Mot de passe */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Mot de passe <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#E87E04] focus:border-[#E87E04] sm:text-sm"
                placeholder="Votre mot de passe"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500"
                >
                  {showPassword ? (
                    <Eye className="h-5 w-5" />
                  ) : (
                    <EyeOff className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>
            <p className="mt-1 text-xs text-gray-500">Minimum 6 caractères</p>
          </div>

          {/* Confirmer mot de passe */}
          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-gray-700"
            >
              Confirmer le mot de passe <span className="text-red-500">*</span>
            </label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                required
                value={passwordConf}
                onChange={(e) => setPasswordConf(e.target.value)}
                className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-[#E87E04] focus:border-[#E87E04] sm:text-sm"
                placeholder="Confirmez votre mot de passe"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500"
                >
                  {showConfirmPassword ? (
                    <Eye className="h-5 w-5" />
                  ) : (
                    <EyeOff className="h-5 w-5" />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Information additionnelle */}
          <div className="bg-blue-50 p-3 rounded-md text-sm text-blue-800">
            <p>
              Veuillez fournir au moins un email ou un numéro de téléphone pour
              créer votre compte.
            </p>
          </div>

          {/* Conditions d'utilisation */}
          <div className="flex items-center">
            <input
              id="terms"
              name="terms"
              type="checkbox"
              required
              className="h-4 w-4 text-[#E87E04] focus:ring-[#E87E04] border-gray-300 rounded"
            />
            <label htmlFor="terms" className="ml-2 block text-sm text-gray-900">
              J'accepte les{" "}
              <span onClick={()=>navigue("/CGVPage")} className="font-medium text-[#E87E04] hover:text-[#B17236] cursor-pointer">
                conditions d'utilisation
              </span>{" "}
              et la{" "}
              <span onClick={()=>navigue("/PolitiqueConfidentialitePage")} className="font-medium text-[#E87E04] hover:text-[#B17236] cursor-pointer">
                politique de confidentialité
              </span>
            </label>
          </div>

          {/* Bouton de soumission */}
          <div>
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#008751] hover:bg-[#B17236] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#008751]"
            >
              S'inscrire
            </button>
          </div>
        </form>

        {/* Autres méthodes d'inscription */}
        {/* <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">
                Ou inscrivez-vous avec
              </span>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-3 gap-3">
            <div>
              <button
                type="button"
                className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
              >
                <span className="sr-only">S'inscrire avec Facebook</span>
                <FacebookIcon />
              </button>
            </div>

            <div>
              <button
                type="button"
                className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
              >
                <span className="sr-only">S'inscrire avec Twitter</span>
                <XIcon />
              </button>
            </div>

            <div>
              <button
                type="button"
                className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
              >
                <span className="sr-only">S'inscrire avec Google</span>
                <GoogleIcon />
              </button>
            </div>
          </div>
        </div> */}

        {/* Lien connexion */}
        <p className="mt-6 text-center text-sm text-gray-500">
          Déjà membre ?{" "}
          <span
            onClick={() => navigation("/Connexion")}
            className="font-medium text-[#008751] hover:text-[#E87E04] cursor-pointer"
          >
            Connectez-vous
          </span>
        </p>
      </div>
      {alert.visible && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ visible: false })}
        />
      )}
    </div>
  );
}

export default Inscription;
